import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Privacy from '../../../components/Privacy';

@withRouter
@inject(root => ({
	auth: root.auth
}))
@observer
export default class PrivacyPolicy extends React.Component {
	render() {
		return <Privacy />;
	}
}



// WEBPACK FOOTER //
// ./src/routes/Viewer/PrivacyPolicy/index.js